import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ViewErrorBoundary } from 'shared/error-boundry';
import { BareLayout } from '../../layout';
import Component from './component';
const BookingViewWrapper = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <BareLayout><ViewErrorBoundary><Component {...props} /></ViewErrorBoundary></BareLayout>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default BookingViewWrapper;